/**
 * Compare two strings
 *
 * @param a
 * @param b
 * @returns
 */
function compareString(a: string, b: string): -1 | 1 | 0 {
  const nameA = a.toUpperCase(); // ignore upper and lowercase
  const nameB = b.toUpperCase(); // ignore upper and lowercase
  if (nameA < nameB) {
    return -1;
  }
  if (nameA > nameB) {
    return 1;
  }

  // names must be equal
  return 0;
}

export default compareString;
